import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Doughnut } from 'react-chartjs-2';
import { Skeleton } from '@material-ui/lab';
import MuiAlert from '@material-ui/lab/Alert';
import { Divider, Backdrop, CircularProgress, Snackbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { GlobalTheme, TileTheme } from "../../layouts/theme";
import { Theme } from "../contexts/themeContext.js";
import { Context } from "../contexts/siteContext.js";
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import CardBody from "../card/cardBody.js";
import CardContent from '@material-ui/core/CardContent';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
        position: "absolute"
    }
}));


export default function SafetyCoachingChart(props) {
    const classes = useStyles();
    const tileClasses = TileTheme();
    const offlineService = new OfflineService();
    const { defaultSite, siteLoading } = useContext(Context);
    const { theme } = useContext(Theme);
    const [loading, setLoading] = useState(true);
    const [backDrop, setBackDrop] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [safe, setSafe] = useState(0);
    const [unsafe, setUnsafe] = useState(0);
    const [total, setTotal] = useState(0)
    const currentTheme = GlobalTheme[theme];

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const linkClicked = (e) => {
        if (defaultSite.IntegratedSystem.TeamCoachId === null || defaultSite.IntegratedSystem.TeamCoachId === "0") {
            e.preventDefault();
            setErrorMessage("The Site " + defaultSite.name + " has not been setup to access Safety Coaching.");
            setOpenError(true);
        }
    };

    const getSafetyCoachingData = () => {
        setBackDrop(true);
        HttpService.post('/SafetyCoaching/GetSafetyCoachSummary', {
            Date: new Date(), SiteId: defaultSite.id
        })
            .then(async (result) => {
                if (result && result.offline) {
                    let offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "SafetyCoachSummary");
                    result = offlineResult.OfflineData;
                }
                else {
                    offlineService.removeOfflineBySite(defaultSite.id, "SafetyCoachSummary");
                    offlineService.addOffline(defaultSite.id, "SafetyCoachSummary", result);
                }

                if (result.data != null) {
                    setSafe(result.data.TotalSafe);
                    setUnsafe(result.data.TotalUnsafe);
                    setTotal(result.data.TotalSafe + result.data.TotalUnsafe);
                    setLoading(false);
                    setBackDrop(false);
                }
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                }
            )
    };

    const chartData = {
        labels: ["Unsafe", "Safe"],
        datasets: [{
            data: total === 0 ? [100, 0] : [(unsafe * 100 / total).toFixed(0), (safe * 100 / total).toFixed(0)],
            backgroundColor: [
                '#99CCFF',
                '#0066CC'
            ]
        }]
    };

    const options = {
        legend: {
            display: false
        },
        responsive: true,
        animation: false,
        cutoutPercentage: 70,
        layout: { padding: 0 },
        tooltips: {
            enabled: total > 0,
            callbacks: {
                title: function (tooltipItem, data) {
                    return data['labels'][tooltipItem[0]['index']];
                },
                label: function (tooltipItem, data) {
                    return data['datasets'][0]['data'][tooltipItem['index']].toString() + ' %';
                }
            }
        }
    };

    useEffect(() => {
        if (!siteLoading)
            getSafetyCoachingData();
        // eslint-disable-next-line 
    }, [props.mode, defaultSite, siteLoading]);

    return (<>
        <div style={{ position: "relative" }}>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Link to={{ pathname: "/SafetyCoachingList" }} onClick={(e) => linkClicked(e)}>
                <Backdrop className={classes.backdrop} id="safetyCoachingBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Card chart color="primary" className={tileClasses.card} style={{ background: currentTheme.background, color: currentTheme.text }} >
                    <CardContent className={tileClasses.cardContent}>
                        <CardHeader>
                            <div className={tileClasses.title}>Safety Coaching</div>
                            {loading === true ? (<Skeleton variant="rect" height={76} />) : (
                                <Doughnut data={chartData} options={options} height={76} />
                            )}
                        </CardHeader>
                        <Divider />
                        <CardBody>
                            <div className={tileClasses.subTitle}>Weekly Summary</div>
                            {loading === true ? (<div><Skeleton variant="text" /><Skeleton variant="text" /></div>) : (
                                <div className="d-flex flex-column">
                                    <label className={tileClasses.optionText}>Total Coachings: {total}</label>
                                    <label className={tileClasses.optionText}>Safe: {safe}</label>
                                    <label className={tileClasses.optionText}>Unsafe: {unsafe}</label>
                                </div>
                            )}
                        </CardBody>
                    </CardContent>
                </Card>
            </Link>
        </div>
    </>
    );
}
